import { useEffect, useState } from "react";
import { ClickAwayListener, IconButton, Tooltip, useMediaQuery } from "@mui/material";
import { usePlantContext } from "../../context/plantContext";
import { formatDate } from "../../services/functions";

export default function PlantClock() {
	const { timezone } = usePlantContext();
	const isMobile = useMediaQuery("(max-width: 680px)");
	const [open, setOpen] = useState(false);
	const [now, setNow] = useState(() => new Date());

	useEffect(() => {
		setOpen(false);
	}, [isMobile]);

	useEffect(() => {
		const interval = window.setInterval(() => setNow(new Date()), 1000);
		return () => window.clearInterval(interval);
	}, []);

	const [hours, minutes, seconds] = formatDate(now, "HH:mm:ss", timezone).split(":").map(Number);
	const hourAngle = (hours % 12) * 30 + minutes * 0.5 + seconds / 120;
	const minuteAngle = minutes * 6 + seconds * 0.1;
	const secondAngle = seconds * 6;

	return (
		<ClickAwayListener onClickAway={() => setOpen(false)}>
			<Tooltip
				open={open}
				onOpen={() => setOpen(true)}
				onClose={() => setOpen(false)}
				disableTouchListener
				disableHoverListener={isMobile}
				disableFocusListener={isMobile}
				describeChild
				arrow
				placement="bottom"
				title={
					<div style={{ textAlign: "center", padding: "4px", fontVariantNumeric: "tabular-nums" }}>
						<div style={{ fontSize: "1rem", whiteSpace: "nowrap" }}>{formatDate(now, "hh:mm:ss A", timezone)}</div>
						<div>{timezone && timezone !== "default" ? timezone : "Local time"}</div>
					</div>
				}
			>
				<IconButton
					aria-label="Show plant time"
					aria-expanded={isMobile ? open : undefined}
					onClick={isMobile ? () => setOpen((previous) => !previous) : undefined}
					onKeyDown={(event) => {
						if (event.key === "Escape") setOpen(false);
					}}
					sx={{
						color: "var(--text-color, #60656c)",
						backgroundColor: "var(--clr-profile-logo)",
						border: "1px solid rgba(128, 128, 128, 0.18)",
						flexShrink: 0,
						width: "2.25rem",
						height: "2.25rem",
						padding: "4px",
						"&:hover": { backgroundColor: "var(--clr-profile-logo)" },
					}}
				>
					<svg width="100%" height="100%" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeLinecap="round" aria-hidden="true" focusable="false">
						<path d="M12 3V4.2M21 12H19.8M12 21V19.8M3 12H4.2" strokeWidth="1.2" opacity="0.4" />
						<path d="M12 12V7" strokeWidth="1.6" transform={`rotate(${hourAngle} 12 12)`} />
						<path d="M12 12V5" strokeWidth="1.2" transform={`rotate(${minuteAngle} 12 12)`} />
						<path d="M12 13.5V4" stroke="var(--primary-color, #ff7200)" strokeWidth="0.8" transform={`rotate(${secondAngle} 12 12)`} />
						<circle cx="12" cy="12" r="1" fill="currentColor" stroke="none" />
					</svg>
				</IconButton>
			</Tooltip>
		</ClickAwayListener>
	);
}
